import { startUploadOrganicContent } from "../actions/user";
import { confirmOrganicPublishRetry } from "../components/Alerts/confirmOrganicPublishRetry";
import {
  buildFailureRowsFromOrganicResults,
  getFailedPlatformsFromOrganicResults,
  isOrganicPublishFullySuccessful,
  readOrganicAutomatedRetryHints,
} from "../utils/organicPublishOutcome";

export const runOrganicPublishRetryFlow = async ({
  dispatch,
  initialPayload,
  initialResponse = null,
  t,
  buildRetryPayload,
}) => {
  let resolvedResponse =
    initialResponse ??
    (await dispatch(startUploadOrganicContent(initialPayload)));

  let failedPlatforms = getFailedPlatformsFromOrganicResults(resolvedResponse);

  while (failedPlatforms.length > 0) {
    const { autoRetryQueued } =
      readOrganicAutomatedRetryHints(resolvedResponse);
    if (autoRetryQueued) {
      break;
    }

    const rows = buildFailureRowsFromOrganicResults(resolvedResponse, t);
    const confirmation = await confirmOrganicPublishRetry({ rows, t });
    if (!confirmation?.isConfirmed) {
      break;
    }

    resolvedResponse = await dispatch(
      startUploadOrganicContent(
        buildRetryPayload({
          failedPlatforms,
          lastResponse: resolvedResponse,
        })
      )
    );
    failedPlatforms = getFailedPlatformsFromOrganicResults(resolvedResponse);
  }

  return {
    response: resolvedResponse,
    isSuccess: isOrganicPublishFullySuccessful(resolvedResponse),
    failedPlatforms: getFailedPlatformsFromOrganicResults(resolvedResponse),
  };
};
